<template>
  <section class="page-join">
    <div class="page-join__content">

      <template v-if="!isGameDownload">
        <h1 class="page-join__title">
          {{ $t("promo.join.title") }}
        </h1>

        <h2 v-if="!isUserInProject" class="page-join__subtitle">
          {{ $t("promo.join.button") }}
        </h2>
      </template>

      <h2 v-if="isGameDownload" class="page-join__download">
        <p>{{ $t("promo.intro.download_text.first") }}</p>
        <p>{{ $t("promo.intro.download_text.second") }}</p>
      </h2>

      <AuthButtons
        v-if="showAuthButtons"
        showMgButtonOnlyForPc
        needLogout
        mgDownload
        @startDownload="onStartDownload"
      />
      <MainButton v-else theme="cta" @click="onButtonClick">{{ buttonText }}</MainButton>

    </div>
  </section>
</template>

<script>
import MainButton from "@static_promo_pages/common/components/redesign/main-button/vue/MainButton.vue";
import AuthButtons from "@static_promo_pages/common/components/redesign/auth-buttons/vue/AuthButtons.vue";

import LoginAndDownloadMixin from "@static_promo_pages/common/mixins/LoginAndDownloadMixin";
import DeviceDetectionMixin from "@godweb/frontend-base/src/mixins/mobile_detection/DeviceDetectionMixin";

export default {
  name: "PageJoin",
  components: {
    MainButton,
    AuthButtons,
  },
  mixins: [LoginAndDownloadMixin, DeviceDetectionMixin],
  props: {
    isGameDownload: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showAuthButtons() {
      return (!this.isUserInProject || !this.isSteamPsXboxUser) && !this.isGameDownload;
    },
    buttonText() {
      return this.isGameDownload ? this.$t("promo.intro.download_button") : this.$t("promo.intro.button");
    },
  },
  methods: {
    onButtonClick() {
      if (this.isSteamPsXboxUser) {
        this.redirectToStore();
      } else if (!this.isWindowsOs) {
        this.redirectToMGStore();
      } else {
        this.$oneLinkEventSender.sendEvent("play");
        if (!!window.__GEM) {
          this.gameDownload("", false, false);
        } else {
          document.addEventListener("GEM_loaded", () => {
            this.gameDownload("", false, false);
          });
        }
      }
    },
    onStartDownload() {
      this.$emit("startDownload");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles";
</style>
